import { render, staticRenderFns } from "./cadastrar_nova_unidade_regiao.vue?vue&type=template&id=01239fe8&scoped=true&"
import script from "./cadastrar_nova_unidade_regiao.vue?vue&type=script&lang=js&"
export * from "./cadastrar_nova_unidade_regiao.vue?vue&type=script&lang=js&"
import style0 from "./cadastrar_nova_unidade_regiao.vue?vue&type=style&index=0&id=01239fe8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01239fe8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VForm,VProgressCircular,VSelect})
